/**
 * Walking the client through the Selections Package (team side). api/selections-review.js;
 * docs/SELECTIONS_PACKAGE_DOCUMENTS.md "Walking the client through it".
 */

async function post(body) {
  const token = window.__clerkGetToken ? await window.__clerkGetToken() : null
  const r = await fetch('/api/selections-review', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: 'Bearer ' + token } : {}) },
    body: JSON.stringify(body),
  })
  const j = await r.json().catch(() => ({}))
  if (!r.ok) throw new Error(j.error || ('Request failed: ' + r.status))
  return j
}

/** { milestone, entryId, published, items, decisions, people, meetings } */
export function loadSelectionsReview(milestoneId) { return post({ action: 'load', milestoneId }) }

/** Record one client answer given in the meeting. Returns { decision }. */
export function recordSelectionAnswer(args) { return post({ action: 'decide', ...args }) }

/** Write the meeting's answers into that meeting's minutes. Returns { threadId, lines, approved }. */
export function writeSelectionsToMinutes(args) { return post({ action: 'toMinutes', ...args }) }
